import StyledRatingContainer from '../../styles/StyledRatingContainer';
import StyledRatingButton from '../../styles/StyledRatingButton';
import thumbUpIcon from '../../assets/svgs/thumbUpIcon.svg';
import thumbDownIcon from '../../assets/svgs/thumbDownIcon.svg';
import thumbUpIconFilled from '../../assets/svgs/thumbUpIconFilled.svg';
import thumbDownIconFilled from '../../assets/svgs/thumbDownIconFilled.svg';
import { ReactSVG } from 'react-svg';
import AppContext from '../../contexts/AppContext';
import AppContextType from '../../types/AppContextType';
import { useContext, useEffect, useState } from 'react';
import { likeConversation, dislikeConversation, getConversationRating } from '../../api/ratingService';
import ConversationContext from '../../contexts/ConversationContext';

const Rating = () => {
  const { configuration, publicKey, appId } = useContext<AppContextType>(AppContext);
  const [currentRating, setCurrentRating] = useState<number>(0);
  const { conversationId } = useContext(ConversationContext);

  const saveRating = (value: number) => {
    if (!window.sessionStorage) return;

    window.sessionStorage.setItem(`dcinnovationChatBotConversationRating_${conversationId}_${appId}`, value.toString());
  };

  const onLikeButtonClick = () => {
    if (!configuration) return;
    if (!publicKey) return;
    if (!conversationId) return;
    if (currentRating === 1) return;

    likeConversation(conversationId, currentRating, publicKey);
    saveRating(1);
    setCurrentRating(1);
  };

  const onDislikeButtonClick = () => {
    if (!configuration) return;
    if (!publicKey) return;
    if (!conversationId) return;
    if (currentRating === -1) return;

    dislikeConversation(conversationId, currentRating, publicKey);
    saveRating(-1);
    setCurrentRating(-1);
  };

  const getCurrentRating = async () => {
    if (!configuration) return;
    if (!publicKey) return;
    if (!conversationId) return;

    const rating: number = await getConversationRating(conversationId, publicKey, appId);
    setCurrentRating(rating);
  };

  useEffect(() => {
    getCurrentRating();
  }, [conversationId]);

  if (!configuration) return <></>;

  return (
    <StyledRatingContainer>
      <StyledRatingButton onClick={onLikeButtonClick} type='button'>
        {currentRating === 1 ? (
          <ReactSVG
            src={thumbUpIconFilled}
            wrapper='span'
            afterInjection={(svg) => {
              svg.classList.add('svg-like-button');
              document.querySelector('.svg-like-button path')?.setAttribute('style', `fill: ${configuration.theme_color}`);
            }}
          />
        ) : (
          <ReactSVG
            src={thumbUpIcon}
            wrapper='span'
            afterInjection={(svg) => {
              svg.classList.add('svg-like-button');
              document.querySelector('.svg-like-button path')?.setAttribute('style', `stroke: ${configuration.theme_color}; fill: #fff`);
            }}
          />
        )}
      </StyledRatingButton>

      <StyledRatingButton onClick={onDislikeButtonClick} type='button'>
        { currentRating === -1 ? (
          <ReactSVG
            src={thumbDownIconFilled}
            wrapper='span'
            afterInjection={(svg) => {
              svg.classList.add('svg-dislike-button');
              document.querySelector('.svg-dislike-button path')?.setAttribute('style', `fill: ${configuration.theme_color}`);
            }}
          />
        ) : (
          <ReactSVG
            src={thumbDownIcon}
            wrapper='span'
            afterInjection={(svg) => {
              svg.classList.add('svg-dislike-button');
              document.querySelector('.svg-dislike-button path')?.setAttribute('style', `stroke: ${configuration.theme_color}; fill: #fff`);
            }}
          />
        )}
      </StyledRatingButton>
    </StyledRatingContainer>
  );
};

export default Rating;